define('views/pages/CheckoutConfirmationPageView',['underscore', 'jquery', 'PageView', 'app', 'router', 'UrlFactory','TagCommander',
        'template!checkout-confirmation',
        'template!blocks/order-recap',
        'views/blocks/AccountOrderView',
        'views/blocks/AddressIconAliasSelectorView',
        'models/OrderModel'
    ],
    function (_, $, PageView, app, router, UrlFactory, TagCommander,
              checkoutConfirmationTemplate,
              recapTemplate,
              AccountOrderView,
              AddressIconAliasSelectorView,
              OrderModel
    ) {

    var view, isWait, order;

    //
    // Checkout Confirmation
    //

    return PageView.extend({
        pageName: 'CheckoutConfirmation',
        hideMobileCart: true,
        hideFooter: true,
        events:{
            'click .delivery-address-alias': 'clickDeliveryAddressAlias',
        },
        initialize: function (options) {

            view = this;
            view.subviews = [];
            var rootEl = view.$('.checkout-confirmation'),
                id_order = rootEl.data('orderid');
            if(id_order){
                order = new OrderModel({id_order: id_order});
            }

            view.listenTo(app,'changeAddressAlias',view.onChangeAddressAlias);

            PageView.prototype.initialize.apply(view, arguments);

            isWait = rootEl.hasClass('wait');
            if (!isWait) {
                // PageView constructor heritage
                view.render();
            } else
            {
                view.listenTo(app, 'newOrderCreate', view.refreshPage);
                view.renderWait();
            }
        },
        refreshPage:function () {
            window.location.reload();
        },
        startPageTagCommander:function(options) {
            TagCommander.LoadPage(this.pageName,{});
        },
        testOrderExist :function(cartID)
        {
            if(!order){
                order = new OrderModel();
            }
            order.testOrderExist(cartID);
            setTimeout(function () {
                view.testOrderExist(cartID);
            }, 5000);

        },
        renderWait: function () {
            var view = this,
                cartID = view.$('.checkout-confirmation').data('cartid');
            view.testOrderExist(cartID);
        },
        clickDeliveryAddressAlias:function(e){
            var view = this,
                currentTarget = $(e.currentTarget),
                id_address = currentTarget.data('id_address'),
                wrapper = view.$('.address-icon-alias-selector__wrapper'),
                address = app.getAddress(id_address);
                wrapper.append('<div class="address-icon-alias-selector__x"></div>');
            view.appendView(AddressIconAliasSelectorView,'.address-icon-alias-selector__x',{type:'account',address:address});
        },
        onChangeAddressAlias:function(deliveryAddress){
            var view = this;
            view.$('.address-alias__value').html(deliveryAddress.formatIcon()+deliveryAddress.formatAliasLabel());
        },
        render: function () {
            var view = this;

            function AppendOrderView(orderModel){
                var orderingView = new AccountOrderView({
                    order: orderModel,
                    tracking: true,
                    trackingdetail: false,
                    target: 'ordering',
                    mode: 'light',
                    autoRefreshOrder: true,
                    type: 'normal'
                });
                view.attachView(orderingView);
                view.$('.suivi').html('').append(orderingView.el);
                orderingView.progessOrderTest();
            }
            if(!order) order = app.getCustomer().getLastOrder();

            if (order){
                order.fetch();
                order.once('sync',function(){
                    AppendOrderView(order);
                })
            }
        }

    });

});

